
export enum StripeProductName {
    PLATFORM = "PLATFORM",
    STRATEGY_BUILDER = "STRATEGY_BUILDER",
    STRATEGY_BUILDER_INTRO = "STRATEGY_BUILDER_INTRO",
    BACKTESTING = "BACKTESTING",
    TRADING_SYSTEMS_ALERTS = "TRADING_SYSTEMS_ALERTS",
    STRESS_TESTING = "STRESS_TESTING",
    CHARTING = "CHARTING",
    LIVE_PRICES = "LIVE_PRICES",
    TRADEFLOOR_PRO = "TRADEFLOOR_PRO"
}
